import DeleteAppSystemWebApiRequestModelBase from '../_generated/modelBases/delete-app-system-web-api-request-model-base';

export default class DeleteAppSystemWebApiRequestModel extends DeleteAppSystemWebApiRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
